import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverRankingDetailAdminDto } from '@/backend/market'
import { DriverRankingAppliedPenaltyModel } from './DriverRankingAppliedPenaltyModel'
import { DriverRankingMetricBreakdownModel } from './DriverRankingMetricBreakdownModel'
import { DriverRankingDetailEntity } from '../../domain/entities/DriverRankingDetailEntity'

export class DriverRankingDetailModel extends DriverRankingDetailEntity {
  constructor(data: DriverRankingDetailAdminDto) {
    super()
    mapEntityProperties(this, data, {
      map: {
        metricBreakdown: data.metricBreakdown
          ? new DriverRankingMetricBreakdownModel(data.metricBreakdown)
          : undefined,
        appliedPenalties: data.appliedPenalties?.map(
          (item) => new DriverRankingAppliedPenaltyModel(item)
        )
      }
    })
  }
}
